import { useContext } from 'react'
import { FeatureContext } from '../'

const useFeature = (name) => {
  const features = useContext(FeatureContext)

  if (typeof name === 'string') {
    let project = null

    if (/^[^.]+\.[^.]+$/.test(name)) {
      ;[, project, name] = name.match(/^([^.]+)\.([^.]+)$/)
    }

    return project ? features && features[project][name] === true : features && features[name] === true
  }

  return features
}

export default useFeature
